/* Article product bar (snippets/main-article-product.liquid): shown once the article's product card has scrolled up
   past the top of the screen, so the card and the bar are never on screen together (one orange button per screen).
   With no card on the page, after the first 400px, as the old sticky bar did. Loaded with defer. */
(function () {
  var bar = document.querySelector('[data-art-bar]');
  if (!bar) return;
  var card = document.querySelector('[data-art-card]');
  var shown = false;

  function setShown(next) {
    if (next === shown) return;
    shown = next;
    bar.classList.toggle('is-shown', shown);
    bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
    if (shown) {
      bar.removeAttribute('inert');
    } else {
      bar.setAttribute('inert', '');
    }
  }

  if (card && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      setShown(!entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
    }).observe(card);
    return;
  }

  function checkScroll() {
    setShown(window.scrollY > 400);
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();
})();
